document.addEventListener('DOMContentLoaded', function() {
  const readMoreLink = document.querySelector('.read-more-link');

  if (readMoreLink) {
    readMoreLink.addEventListener('click', function(e) {
      e.preventDefault();

      // Smooth scroll to tablist
      const tablist = document.getElementById('tablist');
      if (tablist) {
        tablist.scrollIntoView({ behavior: 'smooth' });
      }

      // Trigger click on tab-0 (Description tab)
      const tab0 = document.getElementById('tab-0');
      if (tab0) {
        // Option 1: Trigger native click if tab is JS-controlled
        tab0.click();

        // Option 2: Manually set ARIA attributes (if needed)
        const allTabs = document.querySelectorAll('[role="tab"]');
        const allPanels = document.querySelectorAll('[role="tabpanel"]');

        allTabs.forEach(tab => {
          tab.setAttribute('aria-selected', 'false');
          tab.setAttribute('tabindex', '-1');
        });

        allPanels.forEach(panel => {
          panel.setAttribute('hidden', 'true');
        });

        tab0.setAttribute('aria-selected', 'true');
        tab0.removeAttribute('tabindex');

        const panel0 = document.getElementById('panel-0');
        if (panel0) {
          panel0.removeAttribute('hidden');
          panel0.focus();
        }
      }
    });
  }

  // Select all elements with the 'data-num-results' attribute that are inside a parent with the class 'cc-collection-products'
  const elements = document.querySelectorAll('.cc-collection-products [data-num-results]');

    elements.forEach(el => {
      if (el.getAttribute('data-num-results') === "0") {
        el.style.display = 'none'; // or use: el.classList.add('hidden');
      }
  });
  
});